module.exports = __webpack_public_path__ + "media/images/web/home/index/customers/brand_1-b04fd377ccac4bc027d53dbb278de098.jpg";